export default "__VITE_ASSET__7a1332b7__"